export class BatchItemStockDetails{
    BatchNumber: string;
    Price: number;
    ExpiryDate?: Date;
    Balance: number;
    Currency: string;
}